import { render, staticRenderFns } from "./NotificationBell.vue?vue&type=template&id=20cda86b&scoped=true"
import script from "./NotificationBell.vue?vue&type=script&lang=js"
export * from "./NotificationBell.vue?vue&type=script&lang=js"
import style0 from "./NotificationBell.vue?vue&type=style&index=0&id=20cda86b&prod&scoped=true&lang=css"
import style1 from "./NotificationBell.vue?vue&type=style&index=1&id=20cda86b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cda86b",
  null
  
)

export default component.exports